export default "/_next/static/assets/images/sprite.5946084a865794c4b8a30221602ba97c.svg";